import {
  FailExecuteFavourite, RequestOptionsDrillDownLayoutTypesTo, RequestOptionsDrillDownTo, ResponseOptionsDrillDownLayoutTypesTo,
  ResponseOptionsDrillDownTo
} from "app/area/case-report/risk-listing/action-types";
import { selectRiskReportInstanceState } from "app/area/case-report/risk-listing/selectors";
import { ReplaceRiskReportResults, RequestRiskReportResults } from "app/area/case-report/risk-listing/action-types";
import { errorSafe } from "app/infrastructure/redux";
import { ActionDispatching, ComplexValue, FavouriteDefinition } from "app/types-shared";
import * as routerActions from 'app/area/shared/navigation'
import { actionCreators as favouriteActionCreators } from 'app/area/favourite/actions';
import { selectLayoutTypeForSelectedReport } from "app/area/favourite/selectors";
import { reportLayoutTypeContext } from "app/area/reports/constants";
import { codeItemToStoreValue, storeValueToCodeItem } from "app/infrastructure/data/codes";
import { DrillDownModel } from "app/components/favourite-layout/favourite/common/drill-down-model";
import { RiskReportApi } from "app/area/case-report/risk-listing/types-api";
import { RiskReportLayoutAttributes, defaultMaxCaseNumbers } from "app/area/case-report/risk-listing/constants";

export const actionCreators = (api: RiskReportApi, instanceKey: string) => {
  const {
    setWorkingDefinitionDrillDownReport,
    setWorkingDefinitionDrillDownLayoutType
  } = favouriteActionCreators(instanceKey);

  return {
    executeRiskReport: (
      definition: FavouriteDefinition,
      layoutTypeContextId: number
    ): ActionDispatching<any, any> =>
      errorSafe(async (dispatch: any, getState: any) => {
        dispatch(new RequestRiskReportResults(instanceKey));

        const areaState = selectRiskReportInstanceState(instanceKey)(getState());
        const requestId = areaState?.requestId;
        const layoutType = selectLayoutTypeForSelectedReport(instanceKey)(getState());

        const {
          favourite: { v: favouriteId },
          selectedReport: { v: reportId }
        } = definition;

        try {
          const layoutModel = await api.reportLayout(
            favouriteId,
            reportId,
            layoutType?.v > 0 ? layoutType?.v : 1,
            layoutTypeContextId ?? reportLayoutTypeContext
          );
          const maxCaseNumbersPerCell = Number(
            layoutModel?.layoutTypeAttributes?.[RiskReportLayoutAttributes.MaxCaseNumbersInPopup] ||
            defaultMaxCaseNumbers
          );
          const response = await api.executeRiskReport(definition, maxCaseNumbersPerCell);

          dispatch(new ReplaceRiskReportResults(instanceKey, response, layoutModel, requestId));
        }
        catch (error) {
          if (error?.response?.status === 400) {
            dispatch(new FailExecuteFavourite(instanceKey, error.userMessages.map(m => m.message)));
          }
        }
      }),

    drilldown: (
      definition: FavouriteDefinition,
      drillDownModel: DrillDownModel
    ): ActionDispatching<any, any> =>
      errorSafe(async () => {
        const result = await api.drilldown(definition, drillDownModel);
        routerActions.toCaseListing(result.favourite);
      }),

    setWorkingDefinitionLayoutAttributes:
      (
        attributes: { [key: string]: string | boolean | number }[],
        layoutType: number,
        layoutTypeContext: number
      ): ActionDispatching<any, any> => errorSafe(async () => {
        favouriteActionCreators(instanceKey).setWorkingDefinitionLayoutAttributes(attributes, layoutType, layoutTypeContext);
      }),

    loadOptionsDrillDownTo: (): ActionDispatching<any, any> =>
      errorSafe(async (dispatch: any) => {
        dispatch(new RequestOptionsDrillDownTo(instanceKey));
        const result = await api.loadOptionsDrillDownTo();
        const optionsDrillDownTo = result.data.rootCodes?.map(codeItemToStoreValue);
        dispatch(new ResponseOptionsDrillDownTo(instanceKey, optionsDrillDownTo));
      }
      ),

    onLoadDrilldownLayoutTypes: (reportId: number): ActionDispatching<any, any> =>
      errorSafe(async (dispatch: any, getState: any) => {
        if (reportId) {
          dispatch(new RequestOptionsDrillDownLayoutTypesTo(instanceKey));
          const result = await api.loadDrillDownLayoutTypes(reportId);
          dispatch(new ResponseOptionsDrillDownLayoutTypesTo(instanceKey, result.data));
        }
      }),

    setDrillDownReport:
      (
        drillDownReport: ComplexValue<number>
      ): ActionDispatching<any, any> => errorSafe(async (dispatch: any) => {
        dispatch(setWorkingDefinitionDrillDownReport(storeValueToCodeItem(drillDownReport)));
      }),

    setDrillDownLayoutType:
      (
        drillDownLayoutType: ComplexValue<number>
      ): ActionDispatching<any, any> => errorSafe(async (dispatch: any) => {
        dispatch(setWorkingDefinitionDrillDownLayoutType(storeValueToCodeItem(drillDownLayoutType)));
      })
  };
};
